import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { ProductsServiceInterface } from "@modules/products/services/ProductsServiceInterface";

import { ProductsStackQueryWrapper } from "./ProductsStackQueryWrapper";
import { ProductsStackServiceWrapper } from "./ProductsStackServiceWrapper";

export class ProductsStack {
    public readonly query: ProductsStackQueryWrapper;
    public readonly service: ProductsStackServiceWrapper;

    constructor(
        productsQuery: ProductsQuery,
        productsService: ProductsServiceInterface
    ) {
        this.query = new ProductsStackQueryWrapper(productsQuery);
        this.service = new ProductsStackServiceWrapper(
            productsService,
            productsQuery
        );
    }
}
